export const logAmplitudeEvent = (event) => {
    if(window.amplitude) {
        window.amplitude.getInstance().logEvent(event);
    } else {
        if(window.amplitude) {
            setTimeout(() => window.amplitude.getInstance().logEvent(event), 10000);
        }
    }
};


// WEBPACK FOOTER //
// ./src/util/AmpltudeWrapper.js